import styled from "styled-components";

export const Container = styled.div`
  background: #f9f8f9;
  height:300vh;
`;

export const FirstContainer = styled.div`
  height: 100%;
  background: #ffffff;
  display:grid;
  grid-auto-flow: row;
  @media (min-width: 769px) {
    grid-auto-flow: column;
  }

  & .details{
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    & div{
      max-width: 80%;
      & .details_title{
        text-shadow: 4px 4px 21px rgba(0,0,0,0.6);
        font-size:2.3rem;
        & p{
          margin: 0
        }
       
      }
      & .decription_title{
        font-size: 1rem
      }
      & small{
          display: block;
        }
      & .contact_title{
        margin-top: 1rem;
        display: flex;
        gap:.7rem;

        & img{
          height:3rem;
          cursor: pointer;
        }
      }
    }
  }

  & .images{
    display: flex;
    align-items: center;
    justify-content: center;
    & img{
      width: 70%;
    }
  }
`


export const SecondContainer = styled.div`
  background: #ffffff;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
  & .title_works {
  display: flex;
  align-items: center;
  text-shadow: 4px 4px 21px rgba(0,0,0,0.6);
  font-size:2.3rem;
  }

  & .title_works::after {
    content: '';
    flex: 1;
    margin-left: 1rem;
    height: .2rem;
    background-color: #000;
  }
  & .container_works{
    width: 50rem;
    height: 25rem;
    display: grid;
    grid-template-columns: 20% 80%;
  }
`
export const  SelectWorks = styled.div`
    border-left: ${(props) => (props.status ? "2px solid black" : "0")};
        cursor: pointer;
        padding-left: 1rem;
    height: 3rem;
    color: ${(props) => (props.status ? "gray" : "black")};;
`


export const PrincipalContainer = styled.div`
  height: 100vh;
  align-items: center;
  justify-content: space-around;
  display: flex;
  flex-direction: column;

  @media (min-width: 769px) {

    flex-direction: row;
 
  }

`

export const Image = styled.div`
  height: 25rem;
  overflow: hidden;
  width: 100%;
  @media (min-width: 769px) {
    width: 30rem;


}

`

export const FooterContainer = styled.div`
  height: 100vh;
  background: #ffffff;
`

export const Profile = styled.div`
  
`

export const Button = styled.button`
background: black;
  color: white;
  border-radius: 7px;
  padding: .6rem 2rem;
  font-size: 16px;
  cursor: pointer;
  :disabled {
    opacity: 0.4;
  }
  :hover {
    box-shadow: 0 0 10px yellow;
  }
`